import { render } from "./AlertSample.vue?vue&type=template&id=b84b70a8"
import script from "./AlertSample.vue?vue&type=script&lang=js"
export * from "./AlertSample.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__